import type { ButtonHTMLAttributes, ReactNode } from "react";

import "./Botao.css";

/**
 * As quatro formas de um botão — e por que a quarta existe.
 *
 * <p>{@code primaria} é verde SÓLIDO com texto branco (7.20:1). Isso é metade
 * da regra que sustenta a paleta: com a identidade inteira verde, a cor sozinha
 * deixa de sinalizar, e o que separa "o que eu faço" de "o que a coisa é" passa
 * a ser a FORMA. Nenhum botão é pastel; nenhum selo é sólido.
 *
 * <p>{@code sobreMarca} é para quem vive sobre a faixa verde-900 do cabeçalho.
 * Os outros três foram desenhados para a página branca — o {@code texto} se
 * pinta com a tinta institucional, que sobre o verde-900 dá <b>1.60:1</b> e
 * desaparece. Não é o botão que está errado ali: é a superfície que mudou, e
 * cor de texto é do FUNDO, não do controle.
 */
type Aparencia = "primaria" | "secundaria" | "texto" | "sobreMarca";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  aparencia?: Aparencia;
  /** Ocupa toda a largura — o padrão em formulário de uma coluna. */
  largo?: boolean;
  /**
   * Enquanto verdadeiro, o botão fica desabilitado e anuncia o trabalho em
   * curso. Sem isso, um duplo clique no login dispara duas autenticações e
   * a segunda conta como tentativa no bloqueio.
   */
  carregando?: boolean;
  children: ReactNode;
}

export function Botao({
  aparencia = "primaria",
  largo = false,
  carregando = false,
  disabled,
  children,
  ...resto
}: Props) {
  return (
    <button
      {...resto}
      className={`ui-botao ui-botao--${aparencia}${largo ? " ui-botao--largo" : ""}`}
      disabled={disabled === true || carregando}
      aria-busy={carregando}
    >
      {carregando ? "Aguarde…" : children}
    </button>
  );
}
